import { render, staticRenderFns } from "./UpdatesAndInsights.vue?vue&type=template&id=57cc3628"
import script from "./UpdatesAndInsights.vue?vue&type=script&lang=js"
export * from "./UpdatesAndInsights.vue?vue&type=script&lang=js"
import style0 from "./UpdatesAndInsights.vue?vue&type=style&index=0&id=57cc3628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports